/**
 * MMenu module
 * @module Mmenu
 * @see module: WTM_Libs
 */
define(['wtm_libs', 'mmenuExtensions'], (wtm) => {

    let screen = window.innerWidth,
        wtmMmenu,
        API;

    //check display configuration
    if ((screen >= 1200 && !wtm.mmenu.set__mmenu_display_desktop) || (screen < 1200 && screen >= 768 && !wtm.mmenu.set__mmenu_display_tablet) || (screen <= 768 && !wtm.mmenu.set__mmenu_display_mobile)) return;

    if (screen < 768) {
        wtm.mmenu.set__mmenu_footer_height_desktop = wtm.mmenu.set__mmenu_footer_height_mobile;
        wtm.mmenu.set__mmenu_header_height_desktop = wtm.mmenu.set__mmenu_header_height_mobile;
    }

    if (wtm.debug_mode) console.log('> Mmenu starts;');

    /**
     * MMenu settings
     * @type {Object}
     */
    wtmMmenu = $(wtm.mmenu.get__mmenu_selector).mmenu({
        offCanvas: {
            position: wtm.mmenu.set__mmenu_position,
            zposition: wtm.mmenu.set__mmenu_zposition
        },
        navbars: [{
            position: "bottom",
            content: [wtm.mmenu.set__mmenu_footer],
            height: wtm.mmenu.set__mmenu_footer_height_desktop
        }, {
            position: "top",
            content: [wtm.mmenu.set__mmenu_header],
            height: wtm.mmenu.set__mmenu_header_height_desktop
        }],
        extensions: wtm.mmenu.set__mmenu_extensions
    }, {
        clone: wtm.mmenu.set__menu_clone
    });

    // Set the API
    API = wtmMmenu.data("mmenu");

    //fix for sliding when mmenu opens
    document.getElementsByTagName("html")[0].style.overflow = "scroll";
    document.getElementsByTagName("html")[0].style.overflowX = "hidden";
    API.bind('open', () => {
        disableScroll();
    });
    API.bind('close', () => {
        enableScroll();
    });
    var keys = {
        37: 1,
        38: 1,
        39: 1,
        40: 1
    };
    /**
     * Function to prevent default
     * @param  {Event}
     * @return {boolean}
     */
    function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;
    }
    /**
     * Function to prevent default for arrow keys
     * @param  {Event}
     * @return {boolean}
     */
    function preventDefaultForScrollKeys(e) {
        if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
        }
    }
    /**
     * Function to disable scroll
     * @return {boolean}
     */
    function disableScroll() {
        if (window.addEventListener)
            window.addEventListener('DOMMouseScroll', preventDefault, false);
        window.onwheel = preventDefault;
        window.onmousewheel = document.onmousewheel = preventDefault;
        window.ontouchmove = preventDefault;
        document.onkeydown = preventDefaultForScrollKeys;
    }
    /**
     * Function to enable scroll
     * @return {boolean}
     */
    function enableScroll() {
        if (window.removeEventListener)
            window.removeEventListener('DOMMouseScroll', preventDefault, false);
        window.onmousewheel = document.onmousewheel = null;
        window.onwheel = null;
        window.ontouchmove = null;
        document.onkeydown = null;
    }

    // Clone Top Menu to Footer
    if (document.querySelector(wtm.mmenu.get__bottom_menu_dest)) {
        let target = document.querySelector(wtm.mmenu.get__mmenu_selector).cloneNode(true);
        target.id = "mmenuFooter";
        document.querySelector(wtm.mmenu.get__bottom_menu_dest).appendChild(target);
        submenusIndex(Array.prototype.slice.call(document.querySelectorAll('#' + target.id + " ul > li > ul")));
    }

    //set data-submenu attr
    submenusIndex(Array.prototype.slice.call(document.querySelectorAll(wtm.mmenu.get__mmenu_selector + " ul > li > ul")));
    /**
     * Function to create an array of submenus
     * @param  {Array}
     * @return {void}
     */
    function submenusIndex(array) {
        let incognito;
        document.querySelector('.mm-panels #mm-0') ? incognito = 1 : incognito = 2;
        array.forEach(function(element, index) {
            element.parentNode.setAttribute('data-submenu', index);
            element.parentNode.onclick = function(event) {
                event.preventDefault();
                API.open();
                API.openPanel($("#mm-" + (Number(this.getAttribute('data-submenu')) + incognito)));
            };
        });
    }

    //close 
    document.querySelector(wtm.mmenu.get__mmenu_close_btn).onclick = () => {
        API.close();
    };

    //open in mobile view
    let mobileButtons = document.querySelectorAll(wtm.mmenu.get__mmenu_mobile_btn);
    for (let i = 0; i < mobileButtons.length; i++) {
        mobileButtons[i].onclick = API.open;
    }

    /**
     * Function to update class names for header/footer
     * @param  {string}
     * @param  {string}
     * @param  {string}
     * @return {void}
     */
    function updateClassNames(targetBlock, originalModifier, newModifier) {
        let menuListRaw = document.querySelectorAll(targetBlock + ' *[class*="' + originalModifier + '"]'),
            menuList = [],
            classLookup = new RegExp(originalModifier);
        for (let i = 0; i < menuListRaw.length; i++) {
            menuList[i] = menuListRaw[i];
        }
        for (let i = 0; i < menuList.length; i++) {
            for (let z = 0; z < menuList[i].classList.length; z++) {
                if (classLookup.test(menuList[i].classList.item(z))) {
                    menuList[i].classList.add(menuList[i].classList.item(z).replace(classLookup, newModifier));
                    menuList[i].classList.remove(menuList[i].classList.item(z));
                } else continue;
            }
        }
    }
    updateClassNames("#mm-wtm-mmenu", wtm.mmenu.get__header_modifier, wtm.mmenu.set__mmenu_modifier);
    updateClassNames(wtm.mmenu.get__bottom_menu_dest, wtm.mmenu.get__header_modifier, wtm.mmenu.set__footer_modifier);

    if (wtm.debug_mode) console.log('> Mmenu loaded;');
});